const $inject = [
  "$rootScope",
  "$state",
  "data",
];

class FaxDataController {
  constructor(
    $rootScope,
    $state,
    data
  ) {
    $rootScope.clinics = this.convert_dates(data.clinics);
    $rootScope.hmrs = this.convert_dates(data.hmrs);
    for (let hmr of $rootScope.hmrs) {
      for (let clinic of $rootScope.clinics) {
        if (hmr.clinic.id === clinic.id) {
          hmr.clinic = clinic;
          break;
        }
      }
    }
    if ($state.current.name === "admin.referrals.referral.fax") {
      //noinspection JSCheckFunctionSignatures
      $state.go("admin.referrals.referral.fax.index");
    }
  }

  convert_dates(value, key = null) {
    if (typeof value === "object" && !(value instanceof String)) {
      for (let i in value) {
        if (value.hasOwnProperty(i)) {
          value[i] = this.convert_dates(value[i], i);
        }
      }
    }
    else if ((typeof value === "string" || value instanceof String) &&
      /(^|[\W\d_]|(?=[A-Z]))([Cc]reated|[Mm]odified|[Dd](ate|ob))(?![a-z])/.test(key) &&
      /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d{3})?([+-]\d\d:\d\d|Z)$/.test(value)) {
      let date = new Date(value);
      if (!Number.isNaN(date.getFullYear())) {
        value = date;
      }
    }
    return value;
  }
}

FaxDataController.$inject = $inject;
export default FaxDataController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/fax-data.controller.js
 **/